import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import _Overlay from 'reakit/Overlay';

var getPlacementAttributes = function getPlacementAttributes(props) {
  if (!props.placement) return null;

  var getHiddenAttributes = function getHiddenAttributes(_ref) {
    var transformX = _ref.transformX,
        transformY = _ref.transformY;
    return function (props) {
      return css(["&[aria-hidden='true']{transform:", ";}"], "translate3d(" + (props.slide ? transformX : '0') + ", " + (props.slide ? transformY : '0') + ", 0px) " + (props.expand ? 'scale(0.01)' : ''));
    };
  };

  var placementAttributes = {
    // @ts-ignore
    top: css(["top:", "em;left:50%;transform:translate3d(-50%,0,0px);", ";"], space(5), getHiddenAttributes({
      transformX: '-50%',
      transformY: 'calc(50% - 100%)'
    })),
    // @ts-ignore
    bottom: css(["bottom:", "em;left:50%;transform:translate3d(-50%,0,0px);", ";"], space(5), getHiddenAttributes({
      transformX: '-50%',
      transformY: 'calc(50% + 100%)'
    })),
    // @ts-ignore
    left: css(["top:50%;left:", "em;transform:translate3d(0px,-50%,0px);", ";"], space(5), getHiddenAttributes({
      transformX: 'calc(50% - 100%)',
      transformY: '-50%'
    })),
    // @ts-ignore
    right: css(["top:50%;right:", "em;transform:translate3d(0px,-50%,0px);", ";"], space(5), getHiddenAttributes({
      transformX: 'calc(50% + 100%)',
      transformY: '-50%'
    })),
    // @ts-ignore
    'top-start': css(["top:", "em;left:", "em;transform:translate3d(0,0,0px);", ";"], space(5), space(5), getHiddenAttributes({
      transformX: '0',
      transformY: 'calc(50% - 100%)'
    })),
    // @ts-ignore
    'top-end': css(["top:", "em;right:", "em;transform:translate3d(0,0,0px);", ";"], space(5), space(5), getHiddenAttributes({
      transformX: '0',
      transformY: 'calc(50% - 100%)'
    })),
    // @ts-ignore
    'bottom-end': css(["bottom:", "em;right:", "em;transform:translate3d(0,0,0px);", ";"], space(5), space(5), getHiddenAttributes({
      transformX: '0',
      transformY: 'calc(50% + 100%)'
    })),
    // @ts-ignore
    'bottom-start': css(["bottom:", "em;left:", "em;transform:translate3d(0,0,0px);", ";"], space(5), space(5), getHiddenAttributes({
      transformX: '0',
      transformY: 'calc(50% + 100%)'
    }))
  };
  return css(["top:unset;left:unset;", ";"], placementAttributes[props.placement]);
};
var OverlayHide = styled(_Overlay.Hide).withConfig({
  displayName: "styled__OverlayHide",
  componentId: "sc-1t69wy-0"
})(["", ";"], theme('fannypack.Overlay.Hide.base'));
var OverlayShow = styled(_Overlay.Show).withConfig({
  displayName: "styled__OverlayShow",
  componentId: "sc-1t69wy-1"
})(["", ";"], theme('fannypack.Overlay.Show.base'));
var OverlayToggle = styled(_Overlay.Toggle).withConfig({
  displayName: "styled__OverlayToggle",
  componentId: "sc-1t69wy-2"
})(["", ";"], theme('fannypack.Overlay.Toggle.base'));
var Overlay = styled(_Overlay).withConfig({
  displayName: "styled__Overlay",
  componentId: "sc-1t69wy-3"
})(["&{", ";}", ";"], getPlacementAttributes, theme('fannypack.Overlay.base'));

export default Overlay;
export { Overlay, OverlayHide, OverlayShow, OverlayToggle, getPlacementAttributes };
